import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  page: 1,
  totalPage: 2,
  limit: 10,
  pageInfo: {},

  list: [],
  detail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
